import axios from 'axios';
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Header from '../../Include/Header';
import Sidebar from '../../Include/Sidebar';
import { V_URL } from '../../../../BaseUrl';
import Footer from '../../Include/Footer';

const ManageClass = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state;

  const [form, setForm] = useState({
    className: "",
    thickness: ""
  });
  const [disable, setDisable] = useState(false);
  const [error, setError] = useState('');
  const [selectValue, setSelectValue] = useState('');

  useEffect(() => {
    if (data?._id) {
      setForm({
        className: data?.className,
        thickness: data?.thickness
      });
      setSelectValue(data?.status);
    }
  }, [data]);

  const handleRadioChange = (event) => {
    setSelectValue(event.target.checked);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleSubmit = () => {
    if (validation()) {
      setDisable(true)
      const formData = new URLSearchParams();
      formData.append('className', form.className);
      formData.append('thickness', form.thickness);
      if (data?._id) {
        formData.append('id', data?._id);
        formData.append('status', selectValue);
      }
      axios({
        method: "post",
        url: `${V_URL}/prosafe/manage-class-master`,
        data: formData,
        headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('PAY_USER_TOKEN') },
      }).then((response) => {
        if (response.data.success === true) {
          navigate('/main-store/user/class-management');
          toast.success(response.data.message);
          setForm({
            className: "",
            thickness: ""
          })
        } else {
          toast.error(response.data.message);
        }
      }).catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      }).finally(() => {
        setDisable(false)
      })
    }
  }

  const validation = () => {
    var isValid = true;
    let err = {};
    if (!form.className || !form.className?.trim()) {
      isValid = false;
      err['className_err'] = "Please enter class"
    }
    if (!form.thickness || !form.thickness?.trim()) {
      isValid = false;
      err['thickness_err'] = "Please enter thickness"
    }
    setError(err);
    return isValid;
  }

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }

  return (
    <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>

      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">

          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"><Link to="/main-store/user/dashboard">Dashboard </Link></li>
                  <li className="breadcrumb-item"><i className="feather-chevron-right"></i></li>
                  <li className="breadcrumb-item"><Link to="/main-store/user/class-management">Class List</Link></li>
                  <li className="breadcrumb-item"><i className="feather-chevron-right"></i></li>
                  <li className="breadcrumb-item active">{data?._id ? 'Edit' : 'Add'} Class</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="col-12">
                      <div className="form-heading">
                        <h4>{data?._id ? 'Edit' : 'Add'} Class Details</h4>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12 col-md-4 col-xl-4">
                        <div className="input-block local-forms">
                          <label>Class <span className="login-danger">*</span></label>
                          <input className="form-control" type="text"
                            name='className' onChange={handleChange} value={form.className}
                          />
                          <div className='error'>{error.className_err}</div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 col-xl-4">
                        <div className="input-block local-forms">
                          <label>Thickness(mm) <span className="login-danger">*</span></label>
                          <input className="form-control" type="text"
                            name='thickness' onChange={handleChange} value={form.thickness}
                          />
                          <div className='error'>{error.thickness_err}</div>
                        </div>
                      </div>

                      {data?._id ? (
                        <div className='col-12 col-md-4 col-xl-4'>
                          <div className="cardNum">
                            <div className="mb-3">
                              <label htmlFor="fileUpload" className="form-label">Status</label>
                              <div className="form-check form-switch">
                                <input className="form-check-input" type="checkbox" role="switch" onChange={handleRadioChange} checked={selectValue} />
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <div className="col-12">
                        <div className="doctor-submit text-end">
                          <button type="button"
                            className="btn btn-primary submit-form me-2" onClick={handleSubmit} disabled={disable}>{disable ? "Processing..." : (data?._id ? 'Update' : 'Submit')}</button>
                          <button type="button"
                            className="btn btn-primary cancel-form" onClick={() => setForm({})}>Reset</button>
                        </div>
                      </div>
                    </div>
                  </form>

                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  )
}

export default ManageClass